// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.map-marker-label {
    color: white;
    font-size: 1rem;
    margin-bottom: 15px;
    padding-left: 10px;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}

.gm-style-iw-chr {
    display: none;
}

.gm-map-marker-label {
    height: 5.5rem;
    width: 3.438rem;
    display: flex;
    justify-content: flex-start;
    -webkit-user-select: none;
       -moz-user-select: none;
            user-select: none;
}

.gm-map-marker-label[style*="color: white"] {
    text-shadow:
        -1px -1px 0 #191a1c,
        1px -1px 0 #191a1c,
        -1px 1px 0 #191a1c,
        1px 1px 0 #191a1c;
}

/* Prevent text selection on Google Maps elements */
.gm-style,
.gm-style * {
    -webkit-user-select: none !important;
       -moz-user-select: none !important;
            user-select: none !important;
}
`, "",{"version":3,"sources":["webpack://./src/components/GoogleMaps/ProjectDetailsMaps.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,eAAe;IACf,mBAAmB;IACnB,kBAAkB;IAClB,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,aAAa;IACb,2BAA2B;IAC3B,yBAAiB;OAAjB,sBAAiB;YAAjB,iBAAiB;AACrB;;AAEA;IACI;;;;yBAIqB;AACzB;;AAEA,mDAAmD;AACnD;;IAEI,oCAA4B;OAA5B,iCAA4B;YAA5B,4BAA4B;AAChC","sourcesContent":[".map-marker-label {\n    color: white;\n    font-size: 1rem;\n    margin-bottom: 15px;\n    padding-left: 10px;\n    user-select: none;\n}\n\n.gm-style-iw-chr {\n    display: none;\n}\n\n.gm-map-marker-label {\n    height: 5.5rem;\n    width: 3.438rem;\n    display: flex;\n    justify-content: flex-start;\n    user-select: none;\n}\n\n.gm-map-marker-label[style*=\"color: white\"] {\n    text-shadow:\n        -1px -1px 0 #191a1c,\n        1px -1px 0 #191a1c,\n        -1px 1px 0 #191a1c,\n        1px 1px 0 #191a1c;\n}\n\n/* Prevent text selection on Google Maps elements */\n.gm-style,\n.gm-style * {\n    user-select: none !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
